import * as React from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function ArrowRightIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33337 8H12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.33337L12.6667 8.00004L8 12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CommandIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6667 6V10.6667H6V6H10.6667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66671 6H6.00004V4.66667C6.00004 4.31305 5.85957 3.97391 5.60952 3.72386C5.35947 3.47381 5.02033 3.33334 4.66671 3.33334C4.31309 3.33334 3.97395 3.47381 3.7239 3.72386C3.47385 3.97391 3.33337 4.31305 3.33337 4.66667C3.33337 5.02029 3.47385 5.35943 3.7239 5.60948C3.97395 5.85953 4.31309 6 4.66671 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 6H10V4.66667C10 4.31305 10.1405 3.97391 10.3905 3.72386C10.6406 3.47381 10.9797 3.33334 11.3333 3.33334C11.687 3.33334 12.0261 3.47381 12.2761 3.72386C12.5262 3.97391 12.6667 4.31305 12.6667 4.66667C12.6667 5.02029 12.5262 5.35943 12.2761 5.60948C12.0261 5.85953 11.687 6 11.3333 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 10H10V11.3333C10 11.687 10.1405 12.0261 10.3905 12.2761C10.6406 12.5262 10.9797 12.6667 11.3333 12.6667C11.687 12.6667 12.0261 12.5262 12.2761 12.2761C12.5262 12.0261 12.6667 11.687 12.6667 11.3333C12.6667 10.9797 12.5262 10.6406 12.2761 10.3905C12.0261 10.1405 11.687 10 11.3333 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66671 10H6.00004V11.3333C6.00004 11.687 5.85957 12.0261 5.60952 12.2761C5.35947 12.5262 5.02033 12.6667 4.66671 12.6667C4.31309 12.6667 3.97395 12.5262 3.7239 12.2761C3.47385 12.0261 3.33337 11.687 3.33337 11.3333C3.33337 10.9797 3.47385 10.6406 3.7239 10.3905C3.97395 10.1405 4.31309 10 4.66671 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PlusIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 3.33337V12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33337 8H12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3334 4L6.00004 11.3333L2.66671 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4L4 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4L12 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Plan Field Icons
export function BrandIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.6 5.6H5.2C5.73043 5.6 6.23914 5.38929 6.61421 5.01421C6.98929 4.63914 7.2 4.13043 7.2 3.6C7.2 3.06957 6.98929 2.56086 6.61421 2.18579C6.23914 1.81071 5.73043 1.6 5.2 1.6H1.6V5.6ZM9.6 9.2C9.6 9.67276 9.50688 10.1409 9.32597 10.5777C9.14505 11.0144 8.87988 11.4113 8.54558 11.7456C8.21129 12.0799 7.81443 12.345 7.37766 12.526C6.94089 12.7069 6.47276 12.8 6 12.8H0V0H5.2C5.90477 2.95321e-05 6.59402 0.206922 7.1823 0.595023C7.77058 0.983123 8.232 1.53536 8.50936 2.18326C8.78671 2.83115 8.86779 3.54621 8.74255 4.23975C8.6173 4.9333 8.29124 5.57483 7.8048 6.0848C8.35092 6.40104 8.80427 6.85534 9.11936 7.40212C9.43446 7.9489 9.60021 8.56893 9.6 9.2ZM1.6 7.2V11.2H6C6.53043 11.2 7.03914 10.9893 7.41421 10.6142C7.78929 10.2391 8 9.73043 8 9.2C8 8.66957 7.78929 8.16086 7.41421 7.78579C7.03914 7.41071 6.53043 7.2 6 7.2H1.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IndicationIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3333 13.3333H0.666667C0.489856 13.3333 0.320286 13.2631 0.195262 13.1381C0.0702379 13.013 0 12.8435 0 12.6667V0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 0 0.666667 0H11.3333C11.5101 0 11.6797 0.0702379 11.8047 0.195262C11.9298 0.320286 12 0.489856 12 0.666667V12.6667C12 12.8435 11.9298 13.013 11.8047 13.1381C11.6797 13.2631 11.5101 13.3333 11.3333 13.3333ZM10.6667 12V1.33333H1.33333V12H10.6667ZM3.33333 3.33333H8.66667V4.66667H3.33333V3.33333ZM3.33333 6H8.66667V7.33333H3.33333V6ZM3.33333 8.66667H6.66667V10H3.33333V8.66667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlanDetailsIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6654 14.6668H3.33203C2.8016 14.6668 2.29289 14.4561 1.91782 14.081C1.54274 13.706 1.33203 13.1973 1.33203 12.6668V2.00016C1.33203 1.82335 1.40227 1.65378 1.52729 1.52876C1.65232 1.40373 1.82189 1.3335 1.9987 1.3335H11.332C11.5088 1.3335 11.6784 1.40373 11.8034 1.52876C11.9285 1.65378 11.9987 1.82335 11.9987 2.00016V10.0002H14.6654V12.6668C14.6654 13.1973 14.4546 13.706 14.0796 14.081C13.7045 14.4561 13.1958 14.6668 12.6654 14.6668ZM11.9987 11.3335V12.6668C11.9987 12.8436 12.0689 13.0132 12.194 13.1382C12.319 13.2633 12.4886 13.3335 12.6654 13.3335C12.8422 13.3335 13.0117 13.2633 13.1368 13.1382C13.2618 13.0132 13.332 12.8436 13.332 12.6668V11.3335H11.9987ZM10.6654 13.3335V2.66683H2.66536V12.6668C2.66536 12.8436 2.7356 13.0132 2.86063 13.1382C2.98565 13.2633 3.15522 13.3335 3.33203 13.3335H10.6654ZM3.9987 4.66683H9.33203V6.00016H3.9987V4.66683ZM3.9987 7.3335H9.33203V8.66683H3.9987V7.3335ZM3.9987 10.0002H7.33203V11.3335H3.9987V10.0002Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Image Generation Icons

/**
 * RatioIcon - For aspect ratio/size dropdown in image generation
 */
export function RatioIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9713 4.45312H2.7425C2.43938 4.45312 2.14869 4.5733 1.93435 4.78721C1.72002 5.00112 1.59961 5.29124 1.59961 5.59376V12.4375C1.59961 12.7401 1.72002 13.0302 1.93435 13.2441C2.14869 13.458 2.43938 13.5782 2.7425 13.5782H10.9713C11.2744 13.5782 11.5651 13.458 11.7794 13.2441C11.9937 13.0302 12.1142 12.7401 12.1142 12.4375V5.59376C12.1142 5.29124 11.9937 5.00112 11.7794 4.78721C11.5651 4.5733 11.2744 4.45312 10.9713 4.45312ZM11.657 12.4375C11.657 12.619 11.5848 12.7931 11.4562 12.9215C11.3276 13.0498 11.1531 13.1219 10.9713 13.1219H2.7425C2.56063 13.1219 2.38621 13.0498 2.25761 12.9215C2.12901 12.7931 2.05676 12.619 2.05676 12.4375V5.59376C2.05676 5.41225 2.12901 5.23817 2.25761 5.10983C2.38621 4.98148 2.56063 4.90938 2.7425 4.90938H10.9713C11.1531 4.90938 11.3276 4.98148 11.4562 5.10983C11.5848 5.23817 11.657 5.41225 11.657 5.59376V12.4375Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M11.9039 2.39941C11.8432 2.39941 11.7851 2.42345 11.7422 2.46623C11.6994 2.50901 11.6753 2.56704 11.6753 2.62754V3.08379H2.05676V2.62754C2.05676 2.56704 2.03268 2.50901 1.98981 2.46623C1.94695 2.42345 1.88881 2.39941 1.82819 2.39941C1.76756 2.39941 1.70942 2.42345 1.66656 2.46623C1.62369 2.50901 1.59961 2.56704 1.59961 2.62754V3.9963C1.59961 4.0568 1.62369 4.11482 1.66656 4.15761C1.70942 4.20039 1.76756 4.22442 1.82819 4.22442C1.88881 4.22442 1.94695 4.20039 1.98981 4.15761C2.03268 4.11482 2.05676 4.0568 2.05676 3.9963V3.54004H11.6753V3.9963C11.6753 4.0568 11.6994 4.11482 11.7422 4.15761C11.7851 4.20039 11.8432 4.22442 11.9039 4.22442C11.9645 4.22442 12.0226 4.20039 12.0655 4.15761C12.1084 4.11482 12.1324 4.0568 12.1324 3.9963V2.62754C12.1324 2.56704 12.1084 2.50901 12.0655 2.46623C12.0226 2.42345 11.9645 2.39941 11.9039 2.39941Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M14.1704 4.90938C14.231 4.90938 14.2891 4.88534 14.332 4.84256C14.3748 4.79978 14.3989 4.74175 14.3989 4.68125C14.3989 4.62075 14.3748 4.56272 14.332 4.51994C14.2891 4.47716 14.231 4.45312 14.1704 4.45312H12.7989C12.7383 4.45312 12.6801 4.47716 12.6373 4.51994C12.5944 4.56272 12.5703 4.62075 12.5703 4.68125C12.5703 4.74175 12.5944 4.79978 12.6373 4.84256C12.6801 4.88534 12.7383 4.90938 12.7989 4.90938H13.256V13.1219H12.7989C12.7383 13.1219 12.6801 13.146 12.6373 13.1887C12.5944 13.2315 12.5703 13.2895 12.5703 13.35C12.5703 13.4105 12.5944 13.4686 12.6373 13.5114C12.6801 13.5541 12.7383 13.5782 12.7989 13.5782H13.3909C13.4205 13.5925 13.4529 13.5999 13.4858 13.5999C13.5186 13.5999 13.5511 13.5925 13.5806 13.5782H14.1704C14.231 13.5782 14.2891 13.5541 14.332 13.5114C14.3748 13.4686 14.3989 13.4105 14.3989 13.35C14.3989 13.2895 14.3748 13.2315 14.332 13.1887C14.2891 13.146 14.231 13.1219 14.1704 13.1219H13.7132V4.90938H14.1704Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
}
RatioIcon.displayName = "RatioIcon";

/**
 * VariationsIcon - For variations count dropdown in image generation
 */
export function VariationsIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.45502 13.1123C7.5398 13.1911 7.63617 13.2523 7.73822 13.2979L7.92084 13.4678C7.9851 13.5275 8.07762 13.5625 8.18158 13.5586C8.28653 13.5545 8.39384 13.5101 8.4765 13.4326L8.6142 13.3018C8.72291 13.2548 8.82564 13.1916 8.91498 13.1074L14.2177 8.10742C14.3037 8.27905 14.3475 8.46928 14.3398 8.66504C14.3266 8.99778 14.1729 9.31786 13.9179 9.55762L9.13861 14.0498C8.8835 14.2893 8.54193 14.4335 8.18647 14.4473C7.82998 14.4609 7.48665 14.3418 7.23725 14.1094L1.91205 9.14648C1.66283 8.91404 1.53363 8.59337 1.54682 8.25977C1.55388 8.08257 1.60171 7.90961 1.68256 7.75L7.45502 13.1123Z"
        fill="currentColor"
      />
      <rect
        width="7.89724"
        height="8.43915"
        rx="2"
        transform="matrix(0.728677 0.684857 -0.731621 0.681711 8.65918 1.5498)"
        fill="currentColor"
      />
    </svg>
  );
}
VariationsIcon.displayName = "VariationsIcon";

/**
 * GenerateImagesIcon - For regenerate/generate images button
 */
export function GenerateImagesIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79781 5.11193H2.70744V12.5299L8.24414 7.23133L11.5662 10.4104V7.76118H12.6735V13.0633C12.6725 13.2025 12.6141 13.3359 12.5113 13.4343C12.4085 13.5327 12.2695 13.5884 12.1242 13.5896H3.16595L3.15459 13.5999L3.14324 13.5896H2.14944C2.00372 13.5894 1.86367 13.534 1.76068 13.4354C1.65774 13.3367 1.6001 13.2027 1.6001 13.0633V4.57845C1.60111 4.4393 1.65954 4.3059 1.76231 4.20745C1.86505 4.10912 2.00413 4.05333 2.14944 4.05222H8.79781V5.11193ZM4.27329 12.5299H11.5662V11.9089L8.24414 8.72982L4.27329 12.5299Z"
        fill="currentColor"
      />
      <path
        d="M4.92212 6.17163C5.2158 6.17163 5.49738 6.28336 5.70504 6.48209C5.91271 6.68082 6.02946 6.95028 6.02946 7.23133C6.02946 7.51238 5.91271 7.78184 5.70504 7.98058C5.49738 8.17931 5.2158 8.29104 4.92212 8.29104C4.62843 8.29104 4.34686 8.17931 4.13919 7.98058C3.93153 7.78184 3.81478 7.51238 3.81478 7.23133C3.81478 6.95028 3.93153 6.68082 4.13919 6.48209C4.34686 6.28336 4.62843 6.17163 4.92212 6.17163Z"
        fill="currentColor"
      />
      <path
        d="M11.6006 2.74588C11.7789 2.28458 12.4607 2.28458 12.6391 2.74588L12.9287 3.49493C12.9848 3.63996 13.1043 3.75431 13.2558 3.80798L14.0386 4.08515C14.5206 4.25585 14.5206 4.9083 14.0386 5.079L13.2558 5.35617C13.1043 5.40984 12.9848 5.52419 12.9287 5.66922L12.6391 6.41827C12.4607 6.87957 11.7789 6.87957 11.6006 6.41827L11.3109 5.66922C11.2549 5.52419 11.1354 5.40984 10.9838 5.35617L10.2011 5.079C9.71905 4.9083 9.71905 4.25585 10.2011 4.08515L10.9838 3.80798C11.1354 3.75431 11.2549 3.63996 11.3109 3.49493L11.6006 2.74588Z"
        fill="currentColor"
      />
    </svg>
  );
}
GenerateImagesIcon.displayName = "GenerateImagesIcon";

export function CircleCheckIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.58916 9.31534L3.76249 6.49009L4.70249 5.55056L6.58916 7.43628L11.7625 2.33217L12.7092 3.2717L6.59582 9.31534H6.58916Z"
        fill="currentColor"
      />
      <path
        d="M11.9267 5.96368C11.96 6.1969 11.98 6.43012 11.98 6.67C11.98 9.60187 9.6 11.9807 6.66667 11.9807C3.73333 11.9807 1.35333 9.60187 1.35333 6.67C1.35333 3.73813 3.73333 1.35932 6.66667 1.35932C7.80667 1.35932 8.86 1.71914 9.72667 2.33217L10.6933 1.36598C9.57333 0.513077 8.18 0 6.66667 0C2.98667 0.00666333 0 2.99184 0 6.67C0 10.3482 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3482 13.3333 6.67C13.3333 6.03032 13.24 5.41063 13.0667 4.82425L11.9267 5.96368Z"
        fill="currentColor"
      />
    </svg>
  );
}
CircleCheckIcon.displayName = "CircleCheckIcon";

// Sidebar Icons
export * from "./sidebar";
